import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useToast } from '@chakra-ui/react';
import { db } from "../lib/firebase"
import {
  collection,
  doc,
  getDoc,
  setDoc,
  onSnapshot
} from "firebase/firestore";
import {
  FiImage,
  FiUpload,
  FiX,
  FiHome,
  FiMessageSquare,
  FiCompass,
  FiShuffle,
  FiSmartphone,
  FiSave,
  FiUser,
  FiTrash2,
  FiFileText,
  FiGlobe,
} from 'react-icons/fi';
import { MdImage, MdWallpaper } from 'react-icons/md';

const Customisations = () => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);

  // State for Carousel Banner
  const [carouselBanners, setCarouselBanners] = useState([]);
  const [carouselPreviews, setCarouselPreviews] = useState([]);
  const [carouselFiles, setCarouselFiles] = useState([]);
  const [carouselEnabled, setCarouselEnabled] = useState(true);
  const [selectedGender, setSelectedGender] = useState("male");

  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);


  // State for Group Call Background Templates
  const [groupCallBackgrounds, setGroupCallBackgrounds] = useState([]);
  const [groupCallPreviews, setGroupCallPreviews] = useState([]);
  const [groupCallFiles, setGroupCallFiles] = useState([]);

  // State for Chat Background Templates
  const [chatBackgrounds, setChatBackgrounds] = useState([]);
  const [chatPreviews, setChatPreviews] = useState([]);
  const [chatFiles, setChatFiles] = useState([]);


  const [profileBgCost, setProfileBgCost] = useState(0);
  const [savingCost, setSavingCost] = useState(false);

  // State for Header Images
  const [headerImages, setHeaderImages] = useState({
    home: null,
    random: null,
    chat: null,
    discover: null,
  });
  const [headerPreviews, setHeaderPreviews] = useState({
    home: null,
    random: null,
    chat: null,
    discover: null,
  });
  const [headerFiles, setHeaderFiles] = useState({
    home: null,
    random: null,
    chat: null,
    discover: null,
  });

  // State for Coupon Screen Images
  const couponScreenConfigs = [
    { key: 'coupons-main', label: 'Coupons Main', icon: <FiImage /> },
    { key: 'coupons-list', label: 'Coupons List', icon: <FiImage /> },
  ];

  const [couponScreenPreviews, setCouponScreenPreviews] = useState({
    'coupons-main': null,
    'coupons-list': null,
  });

  const [couponScreenFiles, setCouponScreenFiles] = useState({
    'coupons-main': null,
    'coupons-list': null,
  });

  // State for App Icon
  const [appIcon, setAppIcon] = useState(null);
  const [appIconPreview, setAppIconPreview] = useState(null);
  const [appIconFile, setAppIconFile] = useState(null);

  // State for Splash Screen
  const [splashScreen, setSplashScreen] = useState(null);
  const [splashScreenPreview, setSplashScreenPreview] = useState(null);
  const [splashScreenFile, setSplashScreenFile] = useState(null);

  // State for Profile Avatars
  const [profileAvatars, setProfileAvatars] = useState([]);
  const [profileAvatarPreviews, setProfileAvatarPreviews] = useState([]);
  const [profileAvatarFiles, setProfileAvatarFiles] = useState([]);

  // State for Profile Background Templates
  const [profileBackgrounds, setProfileBackgrounds] = useState([]);
  const [profilePreviews, setProfilePreviews] = useState([]);
  const [profileFiles, setProfileFiles] = useState([]);
  const [profileGenderTab, setProfileGenderTab] = useState('male');

  // State for Force Profile Background Templates
  const [forceProfileBackgrounds, setForceProfileBackgrounds] = useState();
  const [forceProfilePreview, setForceProfilePreview] = useState(null);
  const [forceProfileFile, setForceProfileFile] = useState(null);
  const [forceProfileExpiry, setForceProfileExpiry] = useState(1);
  const [forceProfileGender, setForceProfileGender] = useState('male');

  // State for Welcome Note
  const languages = [
    { value: 'Hindi', label: 'Hindi', v1: 'Hindi', v2: 'Hinglish' },
    { value: 'Telugu', label: 'Telugu', v1: 'Telugu', v2: 'Tinglish' },
    { value: 'Tamil', label: 'Tamil', v1: 'Tamil', v2: 'Tanglish' },
    { value: 'Kannada', label: 'Kannada', v1: 'Kannada', v2: 'Kanglish' },
    { value: 'Malayalam', label: 'Malayalam', v1: 'Malayalam', v2: 'Manglish' },
    { value: 'Marathi', label: 'Marathi', v1: 'Marathi', v2: 'Marathinglish' },
    { value: 'Bengali', label: 'Bengali', v1: 'Bengali', v2: 'Benglish' },
    { value: 'Gujarati', label: 'Gujarati', v1: 'Gujarati', v2: 'Gujlish' },
    { value: 'Punjabi', label: 'Punjabi', v1: 'Punjabi', v2: 'Punglish' },
    { value: 'Oriya', label: 'Oriya', v1: 'Oriya', v2: 'Oringlish' },
    { value: 'Bhojpuri', label: 'Bhojpuri', v1: 'Bhojpuri', v2: 'Bhojlish' },
  ];

  const [welcomeNotes, setWelcomeNotes] = useState({});
  const [selectedLanguage, setSelectedLanguage] = useState('Hindi');
  const [savingWelcomeNote, setSavingWelcomeNote] = useState(false);

  const [activeTab, setActiveTab] = useState('headers');

  // Fetch Welcome Note from Firebase
  useEffect(() => {
    if (!db) return;
    const docRef = doc(db, "settings", "welcome_note");
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        setWelcomeNotes(docSnap.data());
      }
    });
    return () => unsubscribe();
  }, []);

  const saveWelcomeNote = async () => {
    try {
      setSavingWelcomeNote(true);
      if (!db) throw new Error("Firebase not initialized");
      const docRef = doc(db, "settings", "welcome_note");
      await setDoc(docRef, welcomeNotes, { merge: true });
      toast({
        title: "Success",
        description: `Welcome notes updated successfully`,
        status: "success",
      });
    } catch (err) {
      console.error("Error saving welcome note:", err);
      toast({
        title: "Error",
        description: "Failed to update welcome note",
        status: "error",
      });
    } finally {
      setSavingWelcomeNote(false);
    }
  };

  const getWelcomeNoteData = (langValue) => {
    const langConfig = languages.find(l => l.value === langValue);
    const defaultData = {
      male: {
        [langConfig.v1]: { text: "", enabled: true },
        [langConfig.v2]: { text: "", enabled: true }
      },
      female: {
        [langConfig.v1]: { text: "", enabled: true },
        [langConfig.v2]: { text: "", enabled: true }
      }
    };
    return welcomeNotes[langValue] || defaultData;
  };

  const updateWelcomeNoteData = (langValue, gender, variantName, field, value) => {
    const currentData = getWelcomeNoteData(langValue);
    const newData = {
      ...currentData,
      [gender]: {
        ...currentData[gender],
        [variantName]: {
          ...currentData[gender][variantName],
          [field]: value
        }
      }
    };
    setWelcomeNotes(prev => ({
      ...prev,
      [langValue]: newData
    }));
  };

  // Fetch existing customisations on mount
  useEffect(() => {
    fetchCustomisations();
    fetchAppIcon();
    fetchSplashScreen();
    fetchProfileAvatars();
    fetchScreenImages();
    fetchCouponScreenImages();
    fetchBanners();
    fetchGroupCallBackgrounds();
    fetchChatBackgrounds();
    fetchProfileBackgrounds();
    fetchForceProfileBackgrounds();
    fetchProfileBgCost();

  }, []);

  const fetchProfileBgCost = async () => {
    try {
      const res = await axios.get(
        "/api/v2/profileBackgroundConfig/get-profile-bg-cost"
      );

      if (res.data.success) {
        setProfileBgCost(res.data.data.cost);
      }
    } catch (err) {
      console.error("Failed to fetch profile bg cost", err);
    }
  };


  const updateProfileBgCost = async () => {
    try {
      if (!profileBgCost || profileBgCost <= 0) {
        toast({
          title: "Invalid cost",
          status: "warning",
        });
        return;
      }

      setSavingCost(true);

      const res = await axios.post(
        "/api/v2/profileBackgroundConfig/set-profile-bg-cost",
        { cost: profileBgCost }
      );

      if (res.data.success) {
        toast({
          title: "Cost updated",
          description: `New cost: ${profileBgCost} coins`,
          status: "success",
        });
      }
    } catch (err) {
      toast({
        title: "Update failed",
        status: "error",
      });
    } finally {
      setSavingCost(false);
    }
  };

  const fetchCustomisations = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/v1/customisations');
      if (response.data.success) {
        const data = response.data.data;


        // Set group call backgrounds
        if (data.groupCallBackgrounds) {
          setGroupCallBackgrounds(data.groupCallBackgrounds);
        }

        // Set chat backgrounds
        if (data.chatBackgrounds) {
          setChatBackgrounds(data.chatBackgrounds);
        }

        // Set header images
        if (data.headerImages) {
          setHeaderImages(data.headerImages);
          setHeaderPreviews(data.headerImages);
        }



      }
    } catch (error) {
      console.error('Error fetching customisations:', error);
    } finally {
      setLoading(false);
    }
  };




  const fetchBanners = async () => {
    try {
      // 1️⃣ Get banners
      const res = await axios.get("/api/v1/carouselBanner/admin");

      if (res.data.success) {
        setCarouselBanners(res.data.data);
      }

      // 2️⃣ Get carousel toggle status (GLOBAL)
      const statusRes = await axios.get("/api/v2/admin/setting/carousel-status");

      if (statusRes.data.success) {
        setCarouselEnabled(statusRes.data.status);
      }

    } catch (err) {
      console.error("Failed to fetch carousel banners", err);
    }
  };



  const handleUploadChange = (e) => {
    const selectedFiles = Array.from(e.target.files);

    const validFiles = [];
    const newPreviews = [];

    selectedFiles.forEach((file) => {
      if (file.type.startsWith("image/")) {
        validFiles.push(file);
        newPreviews.push(URL.createObjectURL(file));
      }
    });

    setFiles((prev) => [...prev, ...validFiles]);
    setPreviews((prev) => [...prev, ...newPreviews]);
  };


  /* =========================
  REMOVE PREVIEW
  ========================= */

  const removePreview = (index) => {
    const newFiles = files.filter((_, i) => i !== index);
    const newPreviews = previews.filter((_, i) => i !== index);

    setFiles(newFiles);
    setPreviews(newPreviews);
  };



  /* =========================
  UPLOAD BANNERS
  ========================= */

  const uploadBanner = async () => {
    if (files.length === 0) {
      toast({
        title: "Select images first",
        status: "warning",
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();

      files.forEach((file) => {
        formData.append("images", file);
      });

      formData.append("gender", selectedGender);

      const res = await axios.post("/api/v1/carouselBanner", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        toast({
          title: "Banners uploaded successfully",
          status: "success",
        });

        setFiles([]);
        setPreviews([]);

        fetchBanners();
      }
    } catch (err) {
      toast({
        title: err.response?.data?.message || "Upload failed",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  /* =========================
  TOGGLE GROUP STATUS
  ========================= */

  const toggleBanner = async (id) => {
    try {
      const res = await axios.patch(
        `/api/v1/carouselBanner/admin/toggle/${id}`
      );

      if (res.data.success) {
        fetchBanners();

        toast({
          title: "Banner status updated",
          status: "success",
        });
      }
    } catch (err) {
      toast({
        title: "Failed to update banner",
        status: "error",
      });
    }
  };

  /* =========================
  DELETE IMAGE
  ========================= */

  const deleteImage = async (groupId, publicId) => {
    try {
      await axios.delete(`/api/v1/carouselBanner/${groupId}`, {
        data: { publicId },
      });

      fetchBanners();

      toast({
        title: "Banner deleted",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Delete failed",
        status: "error",
      });
    }
  };




  const toggleCarouselStatus = async () => {
    const previousStatus = carouselEnabled;
    const newStatus = !carouselEnabled;

    // UI update instantly
    setCarouselEnabled(newStatus);

    try {
      const res = await axios.put("/api/v2/admin/setting/carousel-toggle");

      if (res.data.success) {
        toast({
          title: "Status Updated",
          description: `Carousel banner is now ${res.data.status ? "ON" : "OFF"}`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        setCarouselEnabled(previousStatus);
      }
    } catch (err) {
      setCarouselEnabled(previousStatus);
      toast({
        title: "Error",
        description: "Failed to update carousel status",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };


  const fetchAppIcon = async () => {
    try {
      const res = await axios.get("/api/v1/app-icon");

      if (res.data.success) {
        setAppIcon(res.data.data);
        setAppIconPreview(res.data.data.url);
      }
    } catch (err) {
      console.log("App icon not found yet");
    }
  };

  const deleteAppIcon = async () => {
    try {
      setLoading(true);

      const res = await axios.delete('/api/v1/app-icon');

      if (res.data.success) {
        toast({
          title: "Deleted",
          description: "App icon deleted successfully",
          status: "success",
        });

        setAppIcon(null);
        setAppIconPreview(null);
        setAppIconFile(null);
      }
    } catch (err) {
      toast({
        title: "Delete failed",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchSplashScreen = async () => {
    try {
      const res = await axios.get("/api/v1/splashScreen");

      if (res.data.success) {
        setSplashScreen(res.data.data);
        setSplashScreenPreview(res.data.data.url);
      }
    } catch (err) {
      console.log("Splash screen not found yet");
    }
  };



  const fetchProfileAvatars = async () => {
    try {
      const res = await axios.get("/api/v2/avtar");

      if (res.data.success) {
        setProfileAvatars(res.data.data);
      }
    } catch (err) {
      console.log("Profile avatars not found yet");
    }
  };




  // Handle Carousel Banner Upload (Multiple)
  const handleCarouselBannerUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const validFiles = [];
    const invalidFiles = [];

    files.forEach(file => {
      if (file.type.startsWith('image/')) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    if (invalidFiles.length > 0) {
      toast({
        title: 'Invalid file type',
        description: `Some files are not images: ${invalidFiles.join(', ')}`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }

    if (validFiles.length > 0) {
      const newFiles = [...carouselFiles, ...validFiles];
      setCarouselFiles(newFiles);

      // Create previews for new files
      const previewPromises = validFiles.map((file, index) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve({ file, preview: reader.result, id: Date.now() + index });
          };
          reader.readAsDataURL(file);
        });
      });

      Promise.all(previewPromises).then((newPreviews) => {
        setCarouselPreviews([...carouselPreviews, ...newPreviews]);
      });
    }
  };


  // Handle Splash Screen Upload
  const handleSplashScreenUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/') && file.type !== 'image/gif') {
        toast({
          title: 'Invalid file type',
          description: 'Please upload an image or gif file',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      setSplashScreenFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setSplashScreenPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSplashScreenSubmit = async () => {
    if (!splashScreenFile) {
      toast({
        title: 'No file selected',
        description: 'Please select an image or gif to upload',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('image', splashScreenFile);
      formData.append('type', 'splash-screen');

      const uploadResponse = await axios.put('/api/v1/splashScreen', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (uploadResponse.data.success) {
        toast({
          title: 'Success',
          description: 'Splash screen updated successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        setSplashScreen(uploadResponse.data.data.url);
      }
    } catch (error) {
      toast({
        title: 'Upload failed',
        description: error.response?.data?.message || 'Failed to update splash screen',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle Profile Avatar Upload (Multiple)
  const handleProfileAvatarUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const validFiles = [];
    const invalidFiles = [];

    files.forEach(file => {
      if (file.type.startsWith('image/')) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    if (invalidFiles.length > 0) {
      toast({
        title: 'Invalid file type',
        description: `Only image files are allowed. Skipped: ${invalidFiles.join(', ')}`,
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
    }

    if (validFiles.length > 0) {
      const newPreviews = validFiles.map(file => URL.createObjectURL(file));
      setProfileAvatarPreviews(prev => [...prev, ...newPreviews]);
      setProfileAvatarFiles(prev => [...prev, ...validFiles]);
    }
  };



  const handleProfileAvatarSubmit = async () => {
    if (profileAvatarFiles.length === 0) {
      toast({
        title: "No files selected",
        status: "warning",
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();

      profileAvatarFiles.forEach(file => {
        formData.append("images", file); // ✅ MUST MATCH BACKEND
      });

      const res = await axios.post("/api/v2/avtar", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        toast({
          title: "Success",
          description: "Profile avatars uploaded successfully",
          status: "success",
        });

        setProfileAvatarFiles([]);
        setProfileAvatarPreviews([]);
        fetchProfileAvatars();
      }
    } catch (err) {
      toast({
        title: "Upload failed",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };


  const removeProfileAvatar = async (id) => {
    try {
      await axios.delete(`/api/v2/avtar/${id}`);

      setProfileAvatars(prev => prev.filter(a => a.id !== id));

      toast({
        title: "Deleted",
        description: "Profile avatar deleted successfully",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Delete failed",
        status: "error",
      });
    }
  };



  const handleCarouselBannerSubmit = async () => {
    if (carouselFiles.length === 0) {
      toast({
        title: "No images selected",
        description: "Please select at least one image to upload",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();

      // 🔥 IMPORTANT: images (plural)
      carouselFiles.forEach((file) => {
        formData.append("images", file);
      });

      formData.append("gender", "both");

      const res = await axios.post(
        "/api/v1/carouselBanner",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        toast({
          title: "Success",
          description: "Carousel banners uploaded successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });


        setCarouselBanners((prev) => [
          ...prev,
          ...res.data.data,
        ]);

        setCarouselFiles([]);
        setCarouselPreviews([]);
        document.getElementById("carousel-banner-upload").value = "";
      }
    } catch (error) {
      toast({
        title: "Upload failed",
        description:
          error.response?.data?.message ||
          "Failed to upload carousel banners",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };


  // Handle Group Call Background Upload (Multiple)
  const handleGroupCallBackgroundUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const validFiles = [];
    const invalidFiles = [];

    files.forEach(file => {
      if (file.type.startsWith('image/')) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    if (invalidFiles.length > 0) {
      toast({
        title: 'Invalid file type',
        description: `Some files are not images: ${invalidFiles.join(', ')}`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }

    if (validFiles.length > 0) {
      const newFiles = [...groupCallFiles, ...validFiles];
      setGroupCallFiles(newFiles);

      // Create previews for new files
      const previewPromises = validFiles.map((file, index) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve({ file, preview: reader.result, id: Date.now() + index });
          };
          reader.readAsDataURL(file);
        });
      });

      Promise.all(previewPromises).then((newPreviews) => {
        setGroupCallPreviews([...groupCallPreviews, ...newPreviews]);
      });
    }
  };



  const handleGroupCallBackgroundSubmit = async () => {
    if (groupCallFiles.length === 0) return;

    try {
      setLoading(true);

      const formData = new FormData();
      groupCallFiles.forEach((file) => {
        formData.append("images", file);
      });

      const res = await axios.post(
        "/api/v1/GroupCallBackground",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.success) {
        toast({
          title: "Success",
          description: "Group call backgrounds uploaded successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // 🔥 IMPORTANT
        fetchGroupCallBackgrounds();

        setGroupCallFiles([]);
        setGroupCallPreviews([]);
        document.getElementById("group-call-background-upload").value = "";
      }
    } catch (err) {
      toast({
        title: "Upload failed",
        description: "Failed to upload group call backgrounds",
        status: "error",
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const removeGroupCallBackground = async (id) => {
    try {
      await axios.delete(`/api/v1/GroupCallBackground/${id}`);

      setGroupCallBackgrounds((prev) =>
        prev.filter((bg) => bg.id !== id)
      );

      toast({
        title: "Deleted",
        description: "Group call background deleted successfully",
        status: "success",
        duration: 2000,
      });
    } catch (err) {
      toast({
        title: "Delete failed",
        description: "Failed to delete group call background",
        status: "error",
        duration: 2000,
      });
    }
  };


  // Handle Header Image Upload
  const handleHeaderImageUpload = (screen, e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast({
          title: 'Invalid file type',
          description: 'Please upload an image file',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      setHeaderFiles({
        ...headerFiles,
        [screen]: file,
      });

      const reader = new FileReader();
      reader.onloadend = () => {
        setHeaderPreviews({
          ...headerPreviews,
          [screen]: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  };



  const handleHeaderImageSubmit = async (screen) => {
    if (!headerFiles[screen]) {
      toast({
        title: "No image selected",
        description: "Please select an image to upload",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("image", headerFiles[screen]);

      const res = await axios.put(
        `/api/v1/screen-image/${screen}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        toast({
          title: "Success",
          description: `${screen} screen image updated successfully`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        setHeaderImages((prev) => ({
          ...prev,
          [screen]: res.data.data.url,
        }));

        setHeaderPreviews((prev) => ({
          ...prev,
          [screen]: res.data.data.url,
        }));

        setHeaderFiles((prev) => ({
          ...prev,
          [screen]: null,
        }));
      }
    } catch (error) {
      toast({
        title: "Upload failed",
        description:
          error.response?.data?.message ||
          `Failed to upload ${screen} screen image`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchGroupCallBackgrounds = async () => {
    try {
      const res = await axios.get("/api/v1/GroupCallBackground");

      if (res.data.success) {
        setGroupCallBackgrounds(res.data.data); // 👈 store full objects
      }
    } catch (err) {
      console.error("Failed to fetch group call backgrounds", err);
    }
  };




  // Handle App Icon Upload
  const handleAppIconUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast({
          title: 'Invalid file type',
          description: 'Please upload an image file',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      setAppIconFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setAppIconPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };


  const handleAppIconSubmit = async () => {
    if (!appIconFile) {
      toast({
        title: 'No image selected',
        status: 'warning',
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append('image', appIconFile);

      let res;

      if (!appIcon) {
        // 🔥 CREATE (first time)
        res = await axios.post('/api/v1/app-icon', formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        // 🔥 UPDATE
        res = await axios.put('/api/v1/app-icon', formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      if (res.data.success) {
        toast({
          title: "Success",
          description: !appIcon
            ? "App icon created successfully"
            : "App icon updated successfully",
          status: "success",
        });

        setAppIcon(res.data.data);
        setAppIconPreview(res.data.data.url);
        setAppIconFile(null);
      }

    } catch (error) {
      toast({
        title: "Error",
        description: error.response?.data?.message || "Something went wrong",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };




  const removeCarouselBanner = async (groupId, publicId) => {
    try {

      await axios.delete(`/api/v1/carouselBanner/${groupId}`, {
        data: { publicId }
      });

      fetchBanners();

      toast({
        title: "Deleted",
        status: "success"
      });

    } catch (err) {

      toast({
        title: "Delete failed",
        status: "error"
      });

    }
  };



  // Handle Chat Background Upload (Multiple)
  const handleChatBackgroundUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const validFiles = [];
    const invalidFiles = [];

    files.forEach(file => {
      if (file.type.startsWith('image/')) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    if (invalidFiles.length > 0) {
      toast({
        title: 'Invalid file type',
        description: `Some files are not images: ${invalidFiles.join(', ')}`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }

    if (validFiles.length > 0) {
      const newFiles = [...chatFiles, ...validFiles];
      setChatFiles(newFiles);

      // Create previews for new files
      const previewPromises = validFiles.map((file, index) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve({ file, preview: reader.result, id: Date.now() + index });
          };
          reader.readAsDataURL(file);
        });
      });

      Promise.all(previewPromises).then((newPreviews) => {
        setChatPreviews([...chatPreviews, ...newPreviews]);
      });
    }
  };


  const handleChatBackgroundSubmit = async () => {
    if (chatFiles.length === 0) {
      toast({
        title: "No images selected",
        status: "warning",
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      chatFiles.forEach((file) => {
        formData.append("images", file); // 👈 MUST be "images"
      });

      const res = await axios.post(
        "/api/v1/chatBackground",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.success) {
        toast({
          title: "Success",
          description: "Chat backgrounds uploaded successfully",
          status: "success",
        });

        fetchChatBackgrounds(); // 🔥 refresh from DB

        setChatFiles([]);
        setChatPreviews([]);
        document.getElementById("chat-background-upload").value = "";
      }
    } catch (err) {
      toast({
        title: "Upload failed",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };




  const removeChatBackground = async (id) => {
    try {
      await axios.delete(`/api/v1/chatBackground/${id}`);

      setChatBackgrounds((prev) =>
        prev.filter((bg) => bg.id !== id)
      );

      toast({
        title: "Deleted",
        description: "Chat background deleted successfully",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Delete failed",
        status: "error",
      });
    }
  };



  const screenConfigs = [
    { key: 'home', label: 'Home', icon: <FiHome /> },
    { key: 'random', label: 'Random', icon: <FiShuffle /> },
    { key: 'chat', label: 'Chat', icon: <FiMessageSquare /> },
    { key: 'discover', label: 'Discover', icon: <FiCompass /> },
  ];

  const tabs = [
    { key: 'headers', label: 'Headers', icon: <FiImage /> },
    { key: 'welcome-note', label: 'Welcome Note', icon: <FiFileText /> },
    { key: 'carousel', label: 'Carousel Banner', icon: <MdImage /> },
    { key: 'profile', label: 'Profile', icon: <FiUser /> },
    { key: 'others', label: 'Others', icon: <FiImage /> },
  ];

  // Handle Profile Background Upload (Multiple)
  const handleProfileBackgroundUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const validFiles = [];
    const invalidFiles = [];

    files.forEach(file => {
      if (file.type.startsWith('image/')) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    if (invalidFiles.length > 0) {
      toast({
        title: 'Invalid file type',
        description: `Some files are not images: ${invalidFiles.join(', ')}`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }

    if (validFiles.length > 0) {
      const newFiles = [...profileFiles, ...validFiles];
      setProfileFiles(newFiles);

      // Create previews for new files
      const previewPromises = validFiles.map((file, index) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve({ file, preview: reader.result, id: Date.now() + index });
          };
          reader.readAsDataURL(file);
        });
      });

      Promise.all(previewPromises).then((newPreviews) => {
        setProfilePreviews([...profilePreviews, ...newPreviews]);
      });
    }
  };


  const handleProfileBackgroundSubmit = async () => {
    if (profileFiles.length === 0) {
      toast({
        title: "No images selected",
        status: "warning",
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      profileFiles.forEach((file) => {
        formData.append("images", file);
      });
      formData.append("gender", profileGenderTab);

      const res = await axios.post(
        "/api/v2/profileBackground",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.success) {
        toast({
          title: "Success",
          description: "Profile backgrounds uploaded successfully",
          status: "success",
        });

        fetchProfileBackgrounds();

        setProfileFiles([]);
        setProfilePreviews([]);
        document.getElementById("profile-background-upload").value = "";
      }
    } catch (err) {
      toast({
        title: "Upload failed",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };


  const removeProfileBackground = async (id) => {
    try {
      await axios.delete(`/api/v2/profileBackground/${id}`);

      setProfileBackgrounds((prev) =>
        prev.filter((bg) => bg.id !== id)
      );

      toast({
        title: "Deleted",
        description: "Profile background deleted successfully",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Delete failed",
        status: "error",
      });
    }
  };

  useEffect(() => {
    fetchProfileBackgrounds();
  }, [profileGenderTab]);

  const fetchProfileBackgrounds = async () => {
    try {
      const res = await axios.get(`/api/v2/profileBackground?gender=${profileGenderTab}`);

      if (res.data.success) {
        setProfileBackgrounds(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch profile backgrounds", err);
    }
  };


  // Handle Force Profile Background Upload
  const handleForceProfileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast({
          title: 'Invalid file type',
          description: 'Please upload an image file',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      setForceProfileFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setForceProfilePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleForceProfileSubmit = async () => {
    if (!forceProfileFile) {
      toast({
        title: "No image selected",
        status: "warning",
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("image", forceProfileFile);
      formData.append("gender", forceProfileGender);
      formData.append("expiryDays", forceProfileExpiry);

      const res = await axios.post(
        "/api/v2/admin/forceprofileBackground",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.success) {
        toast({
          title: "Success",
          description: "Force profile background uploaded successfully",
          status: "success",
        });

        fetchForceProfileBackgrounds();

        setForceProfileFile(null);
        setForceProfilePreview(null);
        setForceProfileExpiry(1);
        document.getElementById("force-profile-upload").value = "";
      }
    } catch (err) {
      toast({
        title: "Upload failed",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

 

  const toggleForceBackground = async () => {
    try {
      if (!forceProfileBackgrounds?.id) return;

      await axios.patch(
        `/api/v2/admin/forceprofileBackground/${forceProfileBackgrounds.id}/deactivate`
      );

      fetchForceProfileBackgrounds();

      toast({
        title: "Deactivated successfully",
        status: "success",
      });

    } catch (err) {
      toast({
        title: "Toggle failed",
        status: "error",
      });
    }
  };



  const removeForceProfileBackground = async () => {
    try {
      await axios.delete(
        `/api/v2/admin/forceprofileBackground/${forceProfileBackgrounds.id}`
      );

      setForceProfileBackgrounds(null);

      toast({
        title: "Deleted",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Delete failed",
        status: "error",
      });
    }
  };




  const fetchForceProfileBackgrounds = async () => {
    try {
      const res = await axios.get(`/api/v2/admin/forceProfileBackground?gender=${forceProfileGender}`);

      if (res.data.success) {
        setForceProfileBackgrounds(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch force profile backgrounds", err);
    }
  };


  useEffect(() => {
    fetchForceProfileBackgrounds();
  }, [forceProfileGender]);




  const renderHeaderCard = (key) => {
    const screen = screenConfigs.find((s) => s.key === key);
    if (!screen) return null;
    return (
      <div className="w-full bg-white border-2 border-gray-200 rounded-xl p-6 mb-6 shadow-sm">
        <div className="flex items-center gap-3 mb-4">
          <div className="text-2xl text-[var(--primary-solid)]">{screen.icon}</div>
          <h3 className="text-lg font-semibold text-[var(--black-text)]">{screen.label} Screen</h3>
        </div>
        {headerPreviews[key] && (
          <div className="mb-4 relative flex justify-center w-full aspect-video">
            <img
              src={headerPreviews[key]}
              alt={`${screen.label} header`}
              className="w-full h-full object-cover rounded-lg border-2 border-gray-200"
            />
          </div>
        )}
        <div className="flex items-center gap-2">
          <label
            htmlFor={`header-${key}-upload`}
            className="cursor-pointer flex-1 px-3 py-2 bg-[var(--primary-solid)] text-white rounded-lg hover:opacity-90 transition flex items-center justify-center gap-2 text-xs font-medium whitespace-nowrap"
          >
            <FiUpload />
            Upload
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleHeaderImageUpload(key, e)}
              className="hidden"
              id={`header-${key}-upload`}
            />
          </label>
          {headerPreviews[key] && (
            <button
              onClick={() => handleHeaderImageSubmit(key)}
              disabled={loading}
              className="flex-1 px-3 py-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-lg hover:shadow-md transition flex items-center justify-center gap-2 disabled:opacity-50 text-xs font-medium whitespace-nowrap"
            >
              <FiSave />
              {loading ? '...' : 'Save'}
            </button>
          )}
        </div>
      </div>
    );
  };

  const fetchScreenImages = async () => {
    try {
      const screens = ["home", "random", "chat", "discover"];
      const previews = {};

      for (const screen of screens) {
        try {
          const res = await axios.get(
            `/api/v1/screen-image/${screen}`
          );

          if (res.data.success) {
            previews[screen] = res.data.data.url;
          }
        } catch (err) {
          // ignore if image not uploaded yet
        }
      }

      setHeaderImages(previews);
      setHeaderPreviews(previews);
    } catch (err) {
      console.error("Error fetching screen images", err);
    }
  };


  const fetchCouponScreenImages = async () => {
    try {
      // Coupons Main Screen
      const mainRes = await axios.get("/api/v2/admin/coupons-main-screen");
      if (mainRes.data.success) {
        setCouponScreenPreviews((prev) => ({
          ...prev,
          "coupons-main": mainRes.data.data.url,
        }));
      }

      // ✅ Coupons List Screen (NEW)
      const listRes = await axios.get("/api/v2/admin/coupons-list-screen");
      if (listRes.data.success) {
        setCouponScreenPreviews((prev) => ({
          ...prev,
          "coupons-list": listRes.data.data.url,
        }));
      }
    } catch (err) {
      console.error("Error fetching coupon screen images", err);
    }
  };


  const handleCouponScreenUpload = (screen, e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      toast({
        title: "Invalid file type",
        description: "Please upload an image file",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setCouponScreenFiles((prev) => ({ ...prev, [screen]: file }));

    const reader = new FileReader();
    reader.onloadend = () => {
      setCouponScreenPreviews((prev) => ({ ...prev, [screen]: reader.result }));
    };
    reader.readAsDataURL(file);
  };



  const handleCouponScreenSubmit = async (screen) => {
    if (!couponScreenFiles[screen]) {
      toast({
        title: "No image selected",
        description: "Please select an image to upload",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("image", couponScreenFiles[screen]);

      // ✅ Dynamic API based on screen
      const apiUrl =
        screen === "coupons-main"
          ? "/api/v2/admin/coupons-main-screen"
          : "/api/v2/admin/coupons-list-screen";

      const res = await axios.put(apiUrl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        toast({
          title: "Success",
          description: `${screen} image updated successfully`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        setCouponScreenPreviews((prev) => ({
          ...prev,
          [screen]: res.data.data.url,
        }));

        setCouponScreenFiles((prev) => ({
          ...prev,
          [screen]: null,
        }));
      }
    } catch (error) {
      toast({
        title: "Upload failed",
        description:
          error.response?.data?.message || `Failed to upload ${screen} image`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };


  const fetchChatBackgrounds = async () => {
    try {
      const res = await axios.get("/api/v1/chatBackground");

      if (res.data.success) {
        setChatBackgrounds(res.data.data); // [{id, url, publicId}]
      }
    } catch (err) {
      console.error("Failed to fetch chat backgrounds", err);
    }
  };





  return (
    <div className="min-h-screen p-6 bg-white text-[var(--black-text)]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8 flex items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-extrabold text-[var(--primary-solid)] flex items-center gap-3 mb-2">
              <FiImage />
              Customisations
            </h1>
            <p className="text-[var(--black-text)]/70">
              Manage app customisations including banners, backgrounds, headers, and app icon
            </p>
          </div>
        </div>

        <div className="mb-6">
          <div className="flex flex-wrap gap-2">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => setActiveTab(t.key)}
                className={`px-4 py-2 rounded-lg border-2 transition flex items-center gap-2 ${activeTab === t.key
                  ? 'bg-[var(--primary-solid)] text-white border-[var(--primary-solid)]'
                  : 'bg-white text-[var(--black-text)] border-gray-200 hover:bg-gray-50'
                  }`}
              >
                {t.icon}
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {activeTab === 'headers' && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {renderHeaderCard('home')}
            {renderHeaderCard('random')}
            {renderHeaderCard('discover')}
            {renderHeaderCard('chat')}
          </div>
        )}

        {activeTab === 'welcome-note' && (
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-6 shadow-sm">
            <div className="flex items-center justify-between mb-8">
              <h2 className="text-2xl font-bold text-[var(--primary-solid)] flex items-center gap-2">
                <FiFileText />
                Welcome Note Configuration
              </h2>
            </div>

            {/* Language Selection Tabs */}
            <div className="mb-8 overflow-x-auto pb-2 scrollbar-hide">
              <div className="flex gap-2 min-w-max">
                {languages.map((lang) => (
                  <button
                    key={lang.value}
                    onClick={() => setSelectedLanguage(lang.value)}
                    className={`px-6 py-2 rounded-xl text-sm font-bold transition-all border-2 ${
                      selectedLanguage === lang.value
                        ? 'bg-[var(--primary-solid)] text-white border-[var(--primary-solid)] shadow-md'
                        : ' text-gray-500 border-gray-100 hover:border-gray-200'
                    }`}
                  >
                    <div className="flex items-center gap-2">
                      <FiGlobe className="text-xs" />
                      {lang.label}
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              {/* Male Welcome Note Section */}
              <div className="space-y-6">
                <div className="flex items-center gap-2 text-blue-600 px-2">
                  <FiUser className="text-2xl" />
                  <h3 className="text-lg font-black uppercase tracking-tighter">Male Welcome Notes</h3>
                </div>
                
                {/* Male - Variant 1 */}
                <div className="p-6  border-2 border-blue-100 rounded-2xl shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-sm font-bold text-blue-700 uppercase">
                      Variant 1: {languages.find(l => l.value === selectedLanguage)?.v1}
                    </h4>
                    <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-lg border border-blue-100">
                      <span className="text-[10px] font-black text-gray-400 uppercase">Status</span>
                      <button
                        onClick={() => updateWelcomeNoteData(selectedLanguage, 'male', languages.find(l => l.value === selectedLanguage)?.v1, 'enabled', !getWelcomeNoteData(selectedLanguage).male[languages.find(l => l.value === selectedLanguage)?.v1].enabled)}
                        className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors duration-200 ${getWelcomeNoteData(selectedLanguage).male[languages.find(l => l.value === selectedLanguage)?.v1].enabled ? 'bg-blue-500' : 'bg-gray-300'}`}
                      >
                        <span className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform duration-200 ${getWelcomeNoteData(selectedLanguage).male[languages.find(l => l.value === selectedLanguage)?.v1].enabled ? 'translate-x-6' : 'translate-x-1'}`} />
                      </button>
                    </div>
                  </div>
                  <textarea
                    value={getWelcomeNoteData(selectedLanguage).male[languages.find(l => l.value === selectedLanguage)?.v1].text}
                    onChange={(e) => updateWelcomeNoteData(selectedLanguage, 'male', languages.find(l => l.value === selectedLanguage)?.v1, 'text', e.target.value)}
                    placeholder={`Enter Male ${languages.find(l => l.value === selectedLanguage)?.v1} note...`}
                    className="w-full h-32 p-4 border-2 border-blue-100 rounded-xl focus:outline-none focus:border-blue-400 bg-white text-sm"
                  />
                </div>

                {/* Male - Variant 2 */}
                <div className="p-6  border-2 border-blue-100 rounded-2xl shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-sm font-bold text-blue-700 uppercase">
                      Variant 2: {languages.find(l => l.value === selectedLanguage)?.v2}
                    </h4>
                    <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-lg border border-blue-100">
                      <span className="text-[10px] font-black text-gray-400 uppercase">Status</span>
                      <button
                        onClick={() => updateWelcomeNoteData(selectedLanguage, 'male', languages.find(l => l.value === selectedLanguage)?.v2, 'enabled', !getWelcomeNoteData(selectedLanguage).male[languages.find(l => l.value === selectedLanguage)?.v2].enabled)}
                        className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors duration-200 ${getWelcomeNoteData(selectedLanguage).male[languages.find(l => l.value === selectedLanguage)?.v2].enabled ? 'bg-blue-500' : 'bg-gray-300'}`}
                      >
                        <span className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform duration-200 ${getWelcomeNoteData(selectedLanguage).male[languages.find(l => l.value === selectedLanguage)?.v2].enabled ? 'translate-x-6' : 'translate-x-1'}`} />
                      </button>
                    </div>
                  </div>
                  <textarea
                    value={getWelcomeNoteData(selectedLanguage).male[languages.find(l => l.value === selectedLanguage)?.v2].text}
                    onChange={(e) => updateWelcomeNoteData(selectedLanguage, 'male', languages.find(l => l.value === selectedLanguage)?.v2, 'text', e.target.value)}
                    placeholder={`Enter Male ${languages.find(l => l.value === selectedLanguage)?.v2} note...`}
                    className="w-full h-32 p-4 border-2 border-blue-100 rounded-xl focus:outline-none focus:border-blue-400 bg-white text-sm"
                  />
                </div>
              </div>

              {/* Female Welcome Note Section */}
              <div className="space-y-6">
                <div className="flex items-center gap-2 text-pink-600 px-2">
                  <FiUser className="text-2xl" />
                  <h3 className="text-lg font-black uppercase tracking-tighter">Female Welcome Notes</h3>
                </div>

                {/* Female - Variant 1 */}
                <div className="p-6  border-2 border-pink-100 rounded-2xl shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-sm font-bold text-pink-700 uppercase">
                      Variant 1: {languages.find(l => l.value === selectedLanguage)?.v1}
                    </h4>
                    <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-lg border border-pink-100">
                      <span className="text-[10px] font-black text-gray-400 uppercase">Status</span>
                      <button
                        onClick={() => updateWelcomeNoteData(selectedLanguage, 'female', languages.find(l => l.value === selectedLanguage)?.v1, 'enabled', !getWelcomeNoteData(selectedLanguage).female[languages.find(l => l.value === selectedLanguage)?.v1].enabled)}
                        className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors duration-200 ${getWelcomeNoteData(selectedLanguage).female[languages.find(l => l.value === selectedLanguage)?.v1].enabled ? 'bg-pink-500' : 'bg-gray-300'}`}
                      >
                        <span className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform duration-200 ${getWelcomeNoteData(selectedLanguage).female[languages.find(l => l.value === selectedLanguage)?.v1].enabled ? 'translate-x-6' : 'translate-x-1'}`} />
                      </button>
                    </div>
                  </div>
                  <textarea
                    value={getWelcomeNoteData(selectedLanguage).female[languages.find(l => l.value === selectedLanguage)?.v1].text}
                    onChange={(e) => updateWelcomeNoteData(selectedLanguage, 'female', languages.find(l => l.value === selectedLanguage)?.v1, 'text', e.target.value)}
                    placeholder={`Enter Female ${languages.find(l => l.value === selectedLanguage)?.v1} note...`}
                    className="w-full h-32 p-4 border-2 border-pink-100 rounded-xl focus:outline-none focus:border-pink-400 bg-white text-sm"
                  />
                </div>

                {/* Female - Variant 2 */}
                <div className="p-6 border-2 border-pink-100 rounded-2xl shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-sm font-bold text-pink-700 uppercase">
                      Variant 2: {languages.find(l => l.value === selectedLanguage)?.v2}
                    </h4>
                    <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-lg border border-pink-100">
                      <span className="text-[10px] font-black text-gray-400 uppercase">Status</span>
                      <button
                        onClick={() => updateWelcomeNoteData(selectedLanguage, 'female', languages.find(l => l.value === selectedLanguage)?.v2, 'enabled', !getWelcomeNoteData(selectedLanguage).female[languages.find(l => l.value === selectedLanguage)?.v2].enabled)}
                        className={`relative inline-flex h-5 w-10 items-center rounded-full transition-colors duration-200 ${getWelcomeNoteData(selectedLanguage).female[languages.find(l => l.value === selectedLanguage)?.v2].enabled ? 'bg-pink-500' : 'bg-gray-300'}`}
                      >
                        <span className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform duration-200 ${getWelcomeNoteData(selectedLanguage).female[languages.find(l => l.value === selectedLanguage)?.v2].enabled ? 'translate-x-6' : 'translate-x-1'}`} />
                      </button>
                    </div>
                  </div>
                  <textarea
                    value={getWelcomeNoteData(selectedLanguage).female[languages.find(l => l.value === selectedLanguage)?.v2].text}
                    onChange={(e) => updateWelcomeNoteData(selectedLanguage, 'female', languages.find(l => l.value === selectedLanguage)?.v2, 'text', e.target.value)}
                    placeholder={`Enter Female ${languages.find(l => l.value === selectedLanguage)?.v2} note...`}
                    className="w-full h-32 p-4 border-2 border-pink-100 rounded-xl focus:outline-none focus:border-pink-400 bg-white text-sm"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-4">
              <button
                onClick={saveWelcomeNote}
                disabled={savingWelcomeNote}
                className="px-10 py-3 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-xl font-black shadow-lg hover:shadow-primary-500/20 transition-all flex items-center gap-2 disabled:opacity-50 uppercase tracking-wider text-sm"
              >
                <FiSave />
                {savingWelcomeNote ? "Saving..." : `Update ${selectedLanguage} Notes`}
              </button>
            </div>
          </div>
        )}

        {activeTab === 'headers' && (
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <MdWallpaper />
                Group Call Background
              </div>
              <label htmlFor="group-call-background-upload" className="cursor-pointer px-4 py-2 bg-[var(--primary-solid)] text-white rounded-lg hover:opacity-90 transition flex items-center gap-2 text-sm font-medium">
                <FiUpload />
                Upload Images
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleGroupCallBackgroundUpload}
                  className="hidden"
                  id="group-call-background-upload"
                />
              </label>
            </h2>
            <p className="text-sm text-[var(--black-text)]/70 mb-4">
              Upload background image for group calls
            </p>

            {/* Preview Area */}
            {groupCallPreviews.length > 0 && (
              <div className="mb-4">
                <div className="mt-4">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                    {groupCallPreviews.map((previewItem, index) => (
                      <div key={previewItem.id || index} className="relative group">
                        <img
                          src={previewItem.preview}
                          alt={`Group call background preview ${index + 1}`}
                          className="w-full h-32 object-cover rounded-lg border-2 border-gray-200"
                        />
                        <button
                          onClick={() => {
                            const newPreviews = groupCallPreviews.filter((_, i) => i !== index);
                            const newFiles = groupCallFiles.filter((_, i) => i !== index);
                            setGroupCallPreviews(newPreviews);
                            setGroupCallFiles(newFiles);
                          }}
                          className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition"
                        >
                          <FiX />
                        </button>
                      </div>
                    ))}
                  </div>
                  <button
                    onClick={handleGroupCallBackgroundSubmit}
                    disabled={loading}
                    className="px-6 py-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-lg hover:shadow-md transition flex items-center gap-2 disabled:opacity-50"
                  >
                    <FiSave />
                    {loading ? 'Uploading...' : `Upload ${groupCallPreviews.length} Background(s)`}
                  </button>
                </div>
              </div>
            )}

            {/* Existing Backgrounds */}
            {groupCallBackgrounds.length > 0 && (
              <div className="mt-6">
                <h3 className="text-lg font-semibold text-[var(--black-text)] mb-3">Existing Backgrounds</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">


                  {groupCallBackgrounds.map((bg) => (
                    <div key={bg.id} className="relative group">
                      <img
                        src={bg.url}
                        alt="Group Call Background"
                        className="w-full h-32 object-cover rounded-lg border-2 border-gray-200"
                      />

                      <button
                        onClick={() => removeGroupCallBackground(bg.id)}
                        className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition"
                      >
                        <FiX />
                      </button>
                    </div>
                  ))}

                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'headers' && (
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <FiMessageSquare />
                Chat Background
              </div>
              <label htmlFor="chat-background-upload" className="cursor-pointer px-4 py-2 bg-[var(--primary-solid)] text-white rounded-lg hover:opacity-90 transition flex items-center gap-2 text-sm font-medium">
                <FiUpload />
                Upload Images
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleChatBackgroundUpload}
                  className="hidden"
                  id="chat-background-upload"
                />
              </label>
            </h2>
            <p className="text-sm text-[var(--black-text)]/70 mb-4">
              Upload background image for chat screens
            </p>

            {/* Preview Area */}
            {chatPreviews.length > 0 && (
              <div className="mb-4">
                <div className="mt-4">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                    {chatPreviews.map((previewItem, index) => (
                      <div key={previewItem.id || index} className="relative group">
                        <img
                          src={previewItem.preview}
                          alt={`Chat background preview ${index + 1}`}
                          className="w-full h-32 object-cover rounded-lg border-2 border-gray-200"
                        />
                        <button
                          onClick={() => {
                            const newPreviews = chatPreviews.filter((_, i) => i !== index);
                            const newFiles = chatFiles.filter((_, i) => i !== index);
                            setChatPreviews(newPreviews);
                            setChatFiles(newFiles);
                          }}
                          className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition"
                        >
                          <FiX />
                        </button>
                      </div>
                    ))}
                  </div>
                  <button
                    onClick={handleChatBackgroundSubmit}
                    disabled={loading}
                    className="px-6 py-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-lg hover:shadow-md transition flex items-center gap-2 disabled:opacity-50"
                  >
                    <FiSave />
                    {loading ? 'Uploading...' : `Upload ${chatPreviews.length} Background(s)`}
                  </button>
                </div>
              </div>
            )}

            {/* Existing Backgrounds */}
            {chatBackgrounds.length > 0 && (
              <div className="mt-6">
                <h3 className="text-lg font-semibold text-[var(--black-text)] mb-3">Existing Chat Backgrounds</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">


                  {chatBackgrounds.length > 0 && (
                    <div className="mt-6">


                      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        {chatBackgrounds.map((bg) => (
                          <div key={bg.id} className="relative group">
                            <img
                              src={bg.url}
                              alt="Chat Background"
                              className="w-full h-32 object-cover rounded-lg border-2 border-gray-200"
                            />

                            <button
                              onClick={() => removeChatBackground(bg.id)}
                              className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition"
                            >
                              <FiX />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                </div>
              </div>
            )}
          </div>
        )}




        {activeTab === 'profile' && (
          <>

            {/* Profile Background Cost Setting */}
            <div className="mb-6 p-4 border-2 border-[var(--primary-solid)]/30 rounded-xl bg-[var(--primary-solid)]/5">
              <h3 className="text-lg font-semibold text-[var(--primary-solid)] mb-3">
                Profile Background Upload Cost
              </h3>

              <div className="flex items-center gap-3">
                <input
                  type="number"
                  value={profileBgCost}
                  onChange={(e) => setProfileBgCost(Number(e.target.value))}
                  className="px-3 py-2 border-2 border-gray-200 rounded-lg w-40 focus:outline-none focus:border-[var(--primary-solid)]"
                  placeholder="Enter coins"
                />

                <span className="text-sm text-gray-500">coins</span>

                <button
                  onClick={updateProfileBgCost}
                  disabled={savingCost}
                  className="px-4 py-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-lg flex items-center gap-2 disabled:opacity-50"
                >
                  <FiSave />
                  {savingCost ? "Saving..." : "Update Cost"}
                </button>
              </div>
            </div>


            <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-6 shadow-sm">
              <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                  <FiUser />
                  Profile Background
                </div>
                <label htmlFor="profile-background-upload" className="cursor-pointer px-4 py-2 bg-[var(--primary-solid)] text-white rounded-lg hover:opacity-90 transition flex items-center gap-2 text-sm font-medium">
                  <FiUpload />
                  Upload Images
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleProfileBackgroundUpload}
                    className="hidden"
                    id="profile-background-upload"
                  />
                </label>
              </h2>
              <p className="text-sm text-[var(--black-text)]/70 mb-4">
                Upload background images for user profiles. Select a gender tab to view/upload for that category.
              </p>

              {/* Gender Tabs */}
              <div className="flex gap-2 mb-6 p-1  rounded-lg w-fit">
                {['male', 'female'].map((gender) => (
                  <button
                    key={gender}
                    onClick={() => setProfileGenderTab(gender)}
                    className={`px-6 py-1.5 text-white text-xl bg-purple-400 btn btn-dark rounded-md text-sm font-medium transition-all ${profileGenderTab === gender
                      ? ' text-[var(--primary-solid)] shadow-sm'
                      : 'text-gray-500 hover:text-gray-700'
                      }`}
                  >
                    {gender.charAt(0).toUpperCase() + gender.slice(1)}
                  </button>
                ))}
              </div>

              {/* Preview Area */}
              {profilePreviews.length > 0 && (
                <div className="mb-6 p-4 border-2 border-dashed border-[var(--primary-solid)]/30 rounded-xl bg-[var(--primary-solid)]/5">
                  <h3 className="text-sm font-semibold text-[var(--primary-solid)] mb-3 flex items-center gap-2">
                    New Backgrounds for {profileGenderTab.charAt(0).toUpperCase() + profileGenderTab.slice(1)}
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                    {profilePreviews.map((previewItem, index) => (
                      <div key={previewItem.id || index} className="relative group">
                        <img
                          src={previewItem.preview}
                          alt={`Profile background preview ${index + 1}`}
                          className="w-full h-32 object-cover rounded-lg border-2 border-gray-200"
                        />
                        <button
                          onClick={() => {
                            const newPreviews = profilePreviews.filter((_, i) => i !== index);
                            const newFiles = profileFiles.filter((_, i) => i !== index);
                            setProfilePreviews(newPreviews);
                            setProfileFiles(newFiles);
                          }}
                          className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition"
                        >
                          <FiX />
                        </button>
                      </div>
                    ))}
                  </div>
                  <button
                    onClick={handleProfileBackgroundSubmit}
                    disabled={loading}
                    className="px-6 py-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-lg hover:shadow-md transition flex items-center gap-2 disabled:opacity-50"
                  >
                    <FiSave />
                    {loading ? 'Uploading...' : `Upload ${profilePreviews.length} Background(s) for ${profileGenderTab}`}
                  </button>
                </div>
              )}

              {/* Existing Backgrounds */}
              <div>
                <h3 className="text-lg font-semibold text-[var(--black-text)] mb-3">
                  Existing {profileGenderTab.charAt(0).toUpperCase() + profileGenderTab.slice(1)} Backgrounds
                </h3>


                {profileBackgrounds.length > 0 ? (
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {profileBackgrounds.map((bg) => (
                      <div key={bg.id} className="relative group">
                        <img
                          src={bg.url}
                          alt="Profile Background"
                          className="w-full h-32 object-cover rounded-lg border-2 border-gray-200"
                        />
                        <button
                          onClick={() => removeProfileBackground(bg.id)}
                          className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition"
                        >
                          <FiX />
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>No backgrounds found</div>
                )}
              </div>
            </div>


          </>
        )}

        {activeTab === 'profile' && (
          <div className="bg-white border-2 border-[var(--primary-solid)]/20 rounded-xl p-6 mb-6 shadow-md">
            <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <FiUser className="text-orange-500" />
                Force Profile Background (Occasions)
              </div>
              <span className="text-xs px-2 py-1 bg-orange-100 text-orange-600 rounded-full font-bold uppercase tracking-wider">
                Overwrite Mode
              </span>
            </h2>
            <p className="text-sm text-[var(--black-text)]/70 mb-6">
              Force a specific background for all users of a selected gender. Useful for events or occasions. This will expire automatically.
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Upload Section */}
              <div className="p-4 bg-gray-50 rounded-xl border-2 border-gray-100">
                <h3 className="text-sm font-bold text-[var(--black-text)] mb-4 uppercase">Set New Force Background</h3>

                <div className="space-y-4">
                  <div>
                    <label className="block text-xs font-bold text-gray-500 mb-2 uppercase">Target Gender</label>
                    <div className="flex gap-2">
                      {['male', 'female'].map((gender) => (
                        <button
                          key={gender}
                          onClick={() => setForceProfileGender(gender)}
                          className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-all ${forceProfileGender === gender
                            ? 'bg-[var(--primary-solid)] text-white'
                            : 'bg-white text-gray-500 border-2 border-gray-200'
                            }`}
                        >
                          {gender.charAt(0).toUpperCase() + gender.slice(1)}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-gray-500 mb-2 uppercase">Expiry (Days)</label>
                    <input
                      type="number"
                      min="1"
                      max="30"
                      value={forceProfileExpiry}
                      onChange={(e) => setForceProfileExpiry(e.target.value)}
                      className="w-full px-3 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-[var(--primary-solid)]"
                    />
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-gray-500 mb-2 uppercase">Select Background</label>
                    <div className="flex items-center gap-3">
                      {forceProfilePreview ? (
                        <div className="relative">
                          <img
                            src={forceProfilePreview}
                            alt="Preview"
                            className="w-24 h-24 object-cover rounded-lg border-2 border-[var(--primary-solid)]"
                          />
                          <button
                            onClick={() => {
                              setForceProfilePreview(null);
                              setForceProfileFile(null);
                            }}
                            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1"
                          >
                            <FiX size={12} />
                          </button>
                        </div>
                      ) : (
                        <label
                          htmlFor="force-profile-upload"
                          className="w-24 h-24 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-[var(--primary-solid)] transition-colors"
                        >
                          <FiUpload className="text-gray-400" />
                          <span className="text-[10px] text-gray-400 font-bold mt-1 uppercase">Upload</span>
                          <input
                            type="file"
                            id="force-profile-upload"
                            accept="image/*"
                            onChange={handleForceProfileUpload}
                            className="hidden"
                          />
                        </label>
                      )}

                      {forceProfileFile && (
                        <button
                          onClick={handleForceProfileSubmit}
                          disabled={loading}
                          className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg font-bold shadow-lg hover:shadow-orange-500/20 transition-all flex items-center justify-center gap-2"
                        >
                          <FiSave />
                          {loading ? 'Processing...' : 'Activate Force Background'}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Active Force Backgrounds Section */}
              <div className="p-4 bg-white rounded-xl border-2 border-gray-100">
                <h3 className="text-sm font-bold text-[var(--black-text)] mb-4 uppercase">Currently Active</h3>
                <div className="space-y-4">

                  {forceProfileBackgrounds ? (
                    <div className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg border border-gray-200">

                      {/* IMAGE */}
                      <img
                        src={forceProfileBackgrounds.url}
                        alt="Force BG"
                        className="w-16 h-16 object-cover rounded-lg"
                      />

                      {/* INFO */}
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-bold text-[var(--primary-solid)] uppercase">
                            {forceProfileBackgrounds.gender}
                          </span>

                          <span className="text-[10px] px-2 py-0.5 bg-green-100 text-green-600 rounded-full font-bold uppercase">
                            {forceProfileBackgrounds.isActive ? "Active" : "Inactive"}
                          </span>
                        </div>

                        <p className="text-[10px] text-gray-500 mt-1">
                          Expires: {new Date(forceProfileBackgrounds.expiresAt).toLocaleDateString()}
                        </p>
                      </div>

                      {/* ACTION BUTTONS */}
                      <div className="flex gap-2">

                        {/* TOGGLE */}
                        <button
                          onClick={toggleForceBackground}
                          className="px-2 py-1 bg-yellow-400 text-white rounded hover:bg-yellow-500 text-xs"
                        >
                          {forceProfileBackgrounds.isActive ? "Deactive" : "Active"}
                        </button>

                        {/* DELETE */}
                        <button
                          onClick={removeForceProfileBackground}
                          className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-xs"
                        >
                          Delete
                        </button>

                      </div>





                      {/* Profile Background Cost Setting */}






                    </div>


                  ) : (
                    <div className="text-gray-400 text-sm">
                      No force background active
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'others' && (
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center gap-2">
              <FiImage />
              Coupon Screens
            </h2>
            <p className="text-sm text-[var(--black-text)]/70 mb-4">
              Upload images for Coupons Main screen and Coupons List screen
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {couponScreenConfigs.map((screen) => (
                <div key={screen.key} className="border-2 border-gray-200 rounded-xl p-4">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="text-2xl text-[var(--primary-solid)]">{screen.icon}</div>
                    <h3 className="text-lg font-semibold text-[var(--black-text)]">{screen.label} Screen</h3>
                  </div>

                  {couponScreenPreviews[screen.key] && (
                    <div className="mb-4 relative">
                      <img
                        src={couponScreenPreviews[screen.key]}
                        alt={`${screen.label} preview`}
                        className="max-w-full h-auto object-contain rounded-lg border-2 border-gray-200"
                      />
                    </div>
                  )}

                  <label
                    htmlFor={`coupon-screen-${screen.key}-upload`}
                    className="cursor-pointer inline-block px-4 py-2 bg-[var(--primary-solid)] text-white rounded-lg hover:opacity-90 transition flex items-center gap-2 text-sm font-medium w-auto mb-2"
                  >
                    <FiUpload />
                    Upload Image
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleCouponScreenUpload(screen.key, e)}
                      className="hidden"
                      id={`coupon-screen-${screen.key}-upload`}
                    />
                  </label>

                  {couponScreenPreviews[screen.key] && (
                    <button
                      onClick={() => handleCouponScreenSubmit(screen.key)}
                      disabled={loading}
                      className="w-full mt-2 px-4 py-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-lg hover:shadow-md transition flex items-center justify-center gap-2 disabled:opacity-50"
                    >
                      <FiSave />
                      {loading ? 'Uploading...' : 'Save Image'}
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'others' && (
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-6 shadow-sm">
            <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <FiSmartphone />
                App Icon
              </div>
              <label htmlFor="app-icon-upload" className="cursor-pointer px-4 py-2 bg-[var(--primary-solid)] text-white rounded-lg hover:opacity-90 transition flex items-center gap-2 text-sm font-medium">
                <FiUpload />
                Upload App Icon
                <input
                  type="file"
                  accept="image/png,image/jpeg"
                  onChange={handleAppIconUpload}
                  className="hidden"
                  id="app-icon-upload"
                />
              </label>
            </h2>
            <p className="text-sm text-[var(--black-text)]/70 mb-4">
              Update the app icon (recommended: 1024x1024px PNG)
            </p>

            <div className="flex flex-col md:flex-row gap-6 items-start">
              {appIconPreview && (
                <div className="relative">
                  <img
                    src={appIconPreview}
                    alt="App icon preview"
                    className="w-32 h-32 object-cover rounded-2xl border-2 border-gray-200 shadow-md"
                  />


                  <button
                    onClick={deleteAppIcon}

                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition"
                  >
                    <FiX />
                  </button>
                </div>
              )}

              <div className="flex-1">
                {appIconPreview && (
                  <button
                    onClick={handleAppIconSubmit}
                    disabled={loading}
                    className="mt-4 px-6 py-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-lg hover:shadow-md transition flex items-center gap-2 disabled:opacity-50"
                  >
                    <FiSave />

                    {appIcon ? "Update App Icon" : "Create App Icon"}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'others' && (
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 shadow-sm">
            <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <FiImage />
                Splash Screen
              </div>
              <label htmlFor="splash-screen-upload" className="cursor-pointer px-4 py-2 bg-[var(--primary-solid)] text-white rounded-lg hover:opacity-90 transition flex items-center gap-2 text-sm font-medium">
                <FiUpload />
                Upload Splash Screen
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleSplashScreenUpload}
                  className="hidden"
                  id="splash-screen-upload"
                />
              </label>
            </h2>
            <p className="text-sm text-[var(--black-text)]/70 mb-4">
              Update the app splash screen (Image or GIF)
            </p>

            <div className="flex flex-col md:flex-row gap-6 items-start">
              {splashScreenPreview && (
                <div className="relative">
                  <img
                    src={splashScreenPreview}
                    alt="Splash screen preview"
                    className="w-48 h-auto object-contain rounded-2xl border-2 border-gray-200 shadow-md"
                  />
                  <button
                    onClick={() => {
                      setSplashScreenPreview(null);
                      setSplashScreenFile(null);
                      document.getElementById('splash-screen-upload').value = '';
                    }}
                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition"
                  >
                    <FiX />
                  </button>
                </div>
              )}

              <div className="flex-1">
                {splashScreenPreview && (
                  <button
                    onClick={handleSplashScreenSubmit}
                    disabled={loading}
                    className="mt-4 px-6 py-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-lg hover:shadow-md transition flex items-center gap-2 disabled:opacity-50"
                  >
                    <FiSave />
                    {loading ? 'Updating...' : 'Update Splash Screen'}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}







        {activeTab === "carousel" && (
          <div className="bg-white border rounded-xl p-6 shadow-sm">

            <h2 className="text-xl font-bold mb-4">
              Carousel Banner
            </h2>

            {/* GENDER SELECT */}

            <div className="flex gap-3 mb-5">

              <button
                onClick={() => setSelectedGender("male")}
                className={`px-4 py-2 rounded ${selectedGender === "male"
                  ? "bg-purple-700"
                  : "bg-purple-500"
                  }`}
              >
                Male
              </button>

              <button
                onClick={() => setSelectedGender("female")}
                className={`px-4 py-2 rounded ${selectedGender === "female"
                  ? "bg-purple-700"
                  : "bg-purple-500"
                  }`}
              >
                Female
              </button>

              <button
                onClick={() => setSelectedGender("both")}
                className={`px-4 py-2 rounded ${selectedGender === "both"
                  ? "bg-purple-700"
                  : "bg-purple-500"
                  }`}
              >
                Both
              </button>

            </div>

            {/* PREVIEW IMAGES */}

            {previews.length > 0 && (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">

                {previews.map((preview, index) => (
                  <div key={index} className="relative">

                    <img
                      src={preview}
                      alt="preview"
                      className="w-full h-32 object-cover rounded"
                    />

                    <button
                      onClick={() => removePreview(index)}
                      className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1"
                    >
                      <FiX />
                    </button>

                  </div>
                ))}

              </div>
            )}

            {/* UPLOAD */}

            <div className="flex gap-3 mb-6">

              <label className="cursor-pointer bg-blue-600 text-white px-4 py-2 rounded flex items-center gap-2">

                <FiUpload />
                Select Images

                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleUploadChange}
                  className="hidden"
                />

              </label>

              <button
                onClick={uploadBanner}
                disabled={loading}
                className="bg-green-600 text-white px-4 py-2 rounded"
              >
                {loading ? "Uploading..." : "Upload"}
              </button>

            </div>

            {/* EXISTING BANNERS */}

            {carouselBanners.map((group) => (

              <div key={group._id} className="mb-6">

                <div className="flex justify-between items-center mb-3">

                  <h3 className="font-semibold text-lg capitalize">
                    {group.gender} banners
                  </h3>

                  <button
                    onClick={() => toggleBanner(group._id)}
                    className={`px-3 py-1 text-xs rounded ${group.isActive
                      ? "bg-green-500 text-white"
                      : "bg-gray-400 text-white"
                      }`}
                  >
                    {group.isActive ? "Active" : "Disabled"}
                  </button>

                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

                  {group.images.map((img) => (

                    <div key={img.publicId} className="relative">

                      <img
                        src={img.url}
                        alt="banner"
                        className="w-full h-32 object-cover rounded"
                      />

                      <button
                        onClick={() => deleteImage(group._id, img.publicId)}
                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1"
                      >
                        <FiX />
                      </button>

                    </div>

                  ))}

                </div>

              </div>

            ))}

          </div>
        )}








        {activeTab === 'others' && (
          <div className="bg-white border-2 border-gray-200 rounded-xl p-6 shadow-sm">
            <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <FiImage />
                Profile Avatars
              </div>
              <label htmlFor="profile-avatar-upload" className="cursor-pointer px-4 py-2 bg-[var(--primary-solid)] text-white rounded-lg hover:opacity-90 transition flex items-center gap-2 text-sm font-medium">
                <FiUpload />
                Upload Avatars
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleProfileAvatarUpload}
                  className="hidden"
                  id="profile-avatar-upload"
                />
              </label>
            </h2>
            <p className="text-sm text-[var(--black-text)]/70 mb-4">
              Upload multiple profile avatar images for users to choose from
            </p>

            {/* Existing Avatars */}
            {profileAvatars.length > 0 && (
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-[var(--primary-solid)] mb-3">Current Profile Avatars</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
                  {profileAvatars.map((avatar, index) => (
                    <div key={avatar._id || index} className="relative group">
                      <img
                        src={avatar.url}
                        alt={`Profile avatar ${index + 1}`}
                        className="w-full h-20 object-cover rounded-lg border-2 border-gray-200"
                      />
                      <button
                        onClick={() => removeProfileAvatar(avatar.id)}
                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition"
                      >
                        <FiX />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* New Upload Previews */}
            {profileAvatarPreviews.length > 0 && (
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-[var(--primary-solid)] mb-3">New Uploads Preview</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
                  {profileAvatarPreviews.map((preview, index) => (
                    <div key={`preview-${index}`} className="relative">
                      <img
                        src={preview}
                        alt={`Preview ${index + 1}`}
                        className="w-full h-20 object-cover rounded-lg border-2 border-gray-200"
                      />
                      <button
                        onClick={() => {
                          const newPreviews = profileAvatarPreviews.filter((_, i) => i !== index);
                          const newFiles = profileAvatarFiles.filter((_, i) => i !== index);
                          setProfileAvatarPreviews(newPreviews);
                          setProfileAvatarFiles(newFiles);
                        }}
                        className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition"
                      >
                        <FiX />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Upload Button */}
            {profileAvatarPreviews.length > 0 && (
              <button
                onClick={handleProfileAvatarSubmit}
                disabled={loading}
                className="mt-4 px-6 py-2 bg-gradient-to-r from-[var(--primary-solid)] to-[var(--primary-dark)] text-white rounded-lg hover:shadow-md transition flex items-center gap-2 disabled:opacity-50"
              >
                <FiSave />
                {loading ? 'Uploading...' : `Upload ${profileAvatarFiles.length} Avatar${profileAvatarFiles.length > 1 ? 's' : ''}`}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Customisations;



